import React, { Component } from 'react';
import { Card, CardBody, CardHeader } from 'reactstrap';
import { Link } from 'react-router-dom';
import ReactTable from 'react-table';
import CompanyContext from '../../../auth/CompanyContext';
class LandingActiveCampaigns extends Component {
  static contextType = CompanyContext;

  constructor(props) {
    super(props);
    this.state = {
      marketingCampaigns: [],
      isLoading: false
    }
  }

  componentDidMount = () => {
    this.getMarketingCampaigns();
  };

  getMarketingCampaigns = (cb) => {
    this.setState({
      isLoading: true,
    },()=> {
      fetch('/api/marketing2Campaigns/active/', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.props.clientToken,
          'X-Database': this.context.company
        }
      })
        .then(results => results.json())
        .then(results => {
          this.setState({
            marketingCampaigns: results.data,
            isLoading: false
          }, () => {
            if (cb != null) cb();
          });
        });
    })
  }

  render() {
    return (
      <Card className='w-100 m-0'>
        <CardHeader className="d-flex justify-content-between align-items-center">
          <h4>Active Campaigns</h4>
          {this.props.icon}
        </CardHeader>
        <CardBody className='p-0'>
          <ReactTable
            data={this.state.marketingCampaigns.filter(campaign => campaign.Activities != null)}
            loading={this.state.isLoading}
            columns={[
              {
                // Expander column
                expander: true,
                Header: '',
                width: 50,
                Expander: ({ isExpanded, ...rest }) =>
                  <div>
                    {isExpanded
                      ? <span>&#x2299;</span> // "Expanded" icon (you can customize this)
                      : <span>&#x2295;</span> // "Collapsed" icon (you can customize this)
                    }
                  </div>,
                style: {
                  cursor: "pointer",
                  fontSize: 25,
                  padding: "0",
                  textAlign: "center",
                  userSelect: "none"
                },
              },
              {
                Header: 'Campaign',
                accessor: 'Campaign',
                filterable: true,
                headerStyle: { textAlign: 'left' },
                minWidth: 200,
                Cell: row =>
                  (<Link to={{ pathname: '/marketing', state: {} }}>{row.original['Campaign']}</Link>),
              },
              {
                Header: '# Companies',
                accessor: 'Campaign',
                style: { textAlign: 'center' },
                filterable: true,
                width: 120,
                Cell: (row) => {
                  return <>{row.original.Activities != null ? row.original.Activities.length : 0}</>
                }
              },
              {
                Header: 'Start Date',
                accessor: 'StartDate',
                filterable: true,
                style: { textAlign: 'right' },
                headerStyle: { textAlign: 'right' },
                Cell: (props) => {
                  return <>{this.props.formatDate(props.value)}</>
                }
              },
              {
                Header: 'End Date',
                accessor: 'EndDate',
                filterable: true,
                style: { textAlign: 'right' },
                headerStyle: { textAlign: 'right' },
                Cell: (props) => {
                  return <>{this.props.formatDate(props.value)}</>
                }
              },


            ]}
            pageSize={this.props.pageSize}
            onPageSizeChange={this.props.setPageSize}
            showPagination={true}
            defaultFilterMethod={this.props.filterCaseInsensitive}
            SubComponent={row => {
              const uniqueActivities = Object.values(row.original.Activities.reduce((acc, curr) => {
                const key = `${curr.Company}-${curr["SEC#"]}`; // Create a unique key based on Company and SEC#
                if (!acc[key] && curr.Company) {
                  acc[key] = { company: curr.Company, secID: curr["SEC#"] }; // Add object if key hasn't been added before
                }
                return acc;
              }, {}));
              const sortedUniqueActivities = uniqueActivities.sort((a, b) => a.company.localeCompare(b.company));
              return (
                <ul style={{ padding: "10px 0" }}>
                  {sortedUniqueActivities.map(item => (
                    <li style={{ padding: "2px 10px 2px 60px", fontSize: "13px" }} key={item.company}>
                      <Link
                        onClick={() => localStorage.setItem('demographicsActiveTab', 7)}
                        to={{ pathname: '/demographics/' + item.secID }}>{item.company}</Link>

                    </li>
                  ))}
                </ul>
              );
            }}
          />
        </CardBody>
      </Card>
    );
  }
}

export default LandingActiveCampaigns;
